import React,{useState,useEffect,useRef} from "react";
import './classes/SalesandAppsReport.css';
import { configData } from "../config";
import Loading from './Loading';
import Select from 'react-dropdown-select';
import { Helmet } from 'react-helmet';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DataGrid } from '@mui/x-data-grid';
 import { Link } from '@mui/material';
 import { format } from "date-fns";

const SalesandAppsReport = ()=>{
     const initialForm = {                  
        start_date:'',
        end_date:'',
        start_date_obj:null,
        end_date_obj:null,
        salesperson:'',
        courses:[],
        payment_method:'All'   
     };     
      const [formData, setFormData] = useState(initialForm);
      const [submittedData, setSubmittedData] = useState(null);
      const [isLoading, setIsLoading] = useState(true);     
      const [courseList, setCourseList] = useState({});
      const[salespersonList, setSalespersonList] = useState({});
      const[summaryData, setSummaryData] = useState({});
      const [formErrors, setFormErrors] =useState({});
     // const [rowData, setRowData] = useState([]);


    // Validation function
    const validateDates = (formData) => {
      let errors = {};

      if (!formData.start_date) {
        errors.start_date = "Start date is required.";
      }

      if (!formData.end_date) {
        errors.end_date = "End date is required.";
      }

      if (formData.start_date && formData.end_date) {
        if (formData.end_date < formData.start_date) {
          errors.end_date = "Start date can't over end date.";
        }
      }

      return errors;
    };

      const app_url = configData.APP_URL;
        useEffect(() => {
           Promise.all([         
          getsalespersonlist(),
          getcourselist(),
          ]).then(() => {     
            setIsLoading(false);
          })
        }, []);
        const startDateRef = useRef(null);
        const endDateRef = useRef(null);
 
  async function getsalespersonlist() {
    
         try {
            const response = await fetch(
                app_url+'user/getsalespersonlistwithunassigned',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        
  }
   async function getcourselist() {
    
         try {
            const response = await fetch(
                app_url+'smwwcommerceproduct/getsalesappreportlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setCourseList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        
  }    
const headers = [
  "Pre-App",
  "Full-App",
  "All Dollars Collected",
  "New Dollars Collected",
  "Sale Amount"
];



 const columnsNewDollar = [
    {
    field: 'user_id',
    headerName: 'User Id',   
    flex:1,  
    sortable: false,
    // minWidth:75,
    cellClassName:'user_id_column',headerClassName:'user_id_header',
  },
  {
    field: 'email',
    headerName: 'Email',      
    flex:1,
    sortable: false,
    // minWidth:150,
    cellClassName:'email_column',headerClassName:'email_header',
  },
  {
    field: 'order_id',
    headerName: 'Order Id',    
    flex:1,
    sortable: false,
    // minWidth:75,
    cellClassName:'order_id_column',headerClassName:'order_id_header',
  },
 
  {
    field: 'sku',
    headerName: 'Sku', 
    sortable: false,  
    flex:1,
    // minWidth:103,
    cellClassName:'sku_column',headerClassName:'sku_header',
  },
  {
    field: 'title',
    headerName: 'Title',   
    flex:1,
    sortable: false,
    // minWidth:150,
    cellClassName:'title_column',headerClassName:'title_header',
  },
  {
    field: 'price_amount',
    headerName: 'Price amount',   
    flex:1,
    sortable: false,
    // minWidth:99,
    cellClassName:'price_amount_column',headerClassName:'price_amount_header',
  },
  {
    field: 'calculated_amount',
    headerName: 'Collected Amount',   
    flex:1,
    sortable: false,
    // minWidth:100,
    cellClassName:'collected_amount_column',headerClassName:'collected_amount_header',
  },

  {
    field: 'sale_amount',
    headerName: 'Sale Amount',   
    flex:1,
    sortable: false,
    // minWidth:99,
    cellClassName:'sale_amount_column',headerClassName:'sale_amount_header',
  },
  {
    field: 'salesperson',
    headerName: 'Salesperson',   
    flex:1,
    sortable: false,
    // minWidth:107,
    cellClassName:'salesperson_column',headerClassName:'salesperson_header',
  },
    {
    field: 'paid_date',
    headerName: 'Paid Date',   
    flex:1,
    sortable: false,
    // minWidth:100,
    cellClassName:'paid_date_column',headerClassName:'paid_date_header',
  },
    {
    field: 'payment_method',
    headerName: 'Payment Method',   
    flex:1,
    sortable: false,
    // minWidth:90,
    cellClassName:'payment_method_column',headerClassName:'payment_method_header',
  },

];
 const columnsRecurringDollar = [
    {
    field: 'user_id',
    headerName: 'User Id',   
    flex:1,  
    sortable: false,
    // minWidth:75,
    cellClassName:'user_id_column',headerClassName:'user_id_header',
  },
  {
    field: 'email',
    headerName: 'Email',      
    flex:1,
    sortable: false,
    // minWidth:150,
    cellClassName:'email_column',headerClassName:'email_header',
  },
  {
    field: 'order_id',
    headerName: 'Order Id',    
    flex:1,
    sortable: false,
    // minWidth:75,
    cellClassName:'order_id_column',headerClassName:'order_id_header',
  },
 
  {
    field: 'sku',
    headerName: 'Sku', 
    sortable: false,  
    flex:1,
    // minWidth:183,
    cellClassName:'sku_column',headerClassName:'sku_header',
  },
  {
    field: 'title',
    headerName: 'Title',   
    flex:1,
    sortable: false,
    // minWidth:250,
    cellClassName:'title_column',headerClassName:'title_header',
  },
 
  {
    field: 'calculated_amount',
    headerName: 'Collected Amount',   
    flex:1,
    sortable: false,
    // minWidth:100,
    cellClassName:'collected_amount_column',headerClassName:'collected_amount_header',
  },

 
  {
    field: 'salesperson',
    headerName: 'Salesperson',   
    flex:1,
    sortable: false,
    // minWidth:125,
    cellClassName:'salesperson_column',headerClassName:'salesperson_header',
  },
    {
    field: 'paid_date',
    headerName: 'Paid Date',   
    flex:1,
    sortable: false,
    // minWidth:100,
    cellClassName:'paid_date_column',headerClassName:'paid_date_header',
  },
    {
    field: 'payment_method',
    headerName: 'Payment Method',   
    flex:1,
    sortable: false,
    // minWidth:90,
    cellClassName:'payment_method_column',headerClassName:'payment_method_header',
  },

];
    /*new dollars collected*/
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });
    
    
    /*recurring dollars collected*/
    const [rowsRecurringDollar, setRowsRecurringDollar] = React.useState([]);
    const [rowCountRecurringDollar, setRowCountRecurringDollar] = React.useState(0);
    const [paginationModelRecurringDollar, setPaginationModelRecurringDollar] = React.useState({ page: 0, pageSize: 50 });
    const [sortModelRecurringDollar, setSortModelRecurringDollar] = React.useState([]);
    const [filterModelRecurringDollar, setFilterModelRecurringDollar] = React.useState({ items: [] });
  const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({
    ...prev,
    [name]: value
  }));
};

    
  // const handleDateChange = (name, date) => {
  //   const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: formattedDate
  //   }));
  // };
  const handleDateChange = (date, field) => {
  setFormData(prev => ({
    ...prev,
    [`${field}_obj`]: date,                       // for DatePicker
    [field]: date ? format(date, 'yyyy-MM-dd') : '' // for backend
  }));
};
    const handleCoursesChange = (e) => {
        const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
        setFormData(prev => ({ ...prev, courses: selectedValues }));
    };
      React.useEffect(() => {
   if(formData.start_date && formData.end_date) {
      const fetchData = async () => {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
       try {
        setIsLoading(true);
      const response = await fetch(app_url+'salesreportbyproduct/getsalesapplist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          recurpage: paginationModelRecurringDollar.page,
          recurpageSize: paginationModelRecurringDollar.pageSize,
          sortModel,
          filterModel,
          formData:formData
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      setRowsRecurringDollar(data.data.recurrows);
      setRowCountRecurringDollar(data.data.recurcount);
      setSummaryData(data.data.summary_details);
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
          
    };
    

    fetchData();
  }
      }, [paginationModel, sortModel, filterModel,paginationModelRecurringDollar]); // Re-fetch data when these change 
    
  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault(); // stop page reload
    const errors = validateDates(formData);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setFormErrors(errors); 
      return;
    }
    setFormErrors({});
    setSubmittedData(formData);
    // Reset pagination state
                setPaginationModel({
                 page: 0,
                    pageSize: 50,
                 });
                  setPaginationModelRecurringDollar({
                 page: 0,
                    pageSize: 50,
                 });
     try {
        setIsLoading(true);
      const response = await fetch(app_url+'salesreportbyproduct/getsalesapplist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
           page: 0,
               pageSize: 50,
           recurpage: 0,
          recurpageSize: 50,
          sortModel,
          filterModel,
          formData:formData
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
       setRowsRecurringDollar(data.data.recurrows);
      setRowCountRecurringDollar(data.data.recurcount);
       setSummaryData(data.data.summary_details);
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    console.log("Form submitted:", formData);


  };
  const handleExport = async (e) => {
    e.preventDefault(); // stop page reload
    const errors = validateDates(formData);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setFormErrors(errors); 
      return;
    }
    setFormErrors({});   
     try {
        setIsLoading(true);
        const response = await fetch(app_url+'salesreportbyproduct/getsalesappexport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          
          formData:formData
        }),
      });
      const data = await response.json();
    const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }


  };

  return(
      <>
        {isLoading ? (
          <Loading />
        ) : (
        <div id="main" className="sales-apps-reports-main">
          <Helmet>
            <title>
              Sales & Apps Report | SMWW
            </title>
          </Helmet>
          <div className="left"></div>
          <div className="center left-center">
              <div className="sales-apps-report-container">
                <h1>Sales & Apps Report</h1>
                <form onSubmit={handleSubmit}>
                  <div>
                    <label htmlFor="pay_start_date">Payment Start Date:</label>
                    <DatePicker
                     ref={startDateRef}
                      selected={formData.start_date_obj}
                      onChange={(date) => {handleDateChange(date, 'start_date');
                            setTimeout(() => {
                                const input = startDateRef.current?.input;
                                if (input) {
                                  const len = input.value.length;
                                  input.setSelectionRange(len, len);
                                }
                              }, 0);
                      }}
                      name="start_date"
                      id="pay_start_date"
                      // required
                    /> 
                    {formErrors.start_date && (
                      <div className="error">{formErrors.start_date}</div>
                    )} 
                    <label htmlFor="pay_end_date">Payment End Date:</label>
                    <DatePicker
                    ref={endDateRef}
                      selected={formData.end_date_obj}
                      onChange={(date) => {handleDateChange(date, 'end_date');
                            setTimeout(() => {
                                const input = endDateRef.current?.input;
                                if (input) {
                                  const len = input.value.length;
                                  input.setSelectionRange(len, len);
                                }
                              }, 0);
                      }}
                      name="end_date"
                      id="pay_end_date"
                      // required
                    />
                      {formErrors.end_date && (
                        <div className="error">{formErrors.end_date}</div>
                      )}
                                                                
                    <label>Salesperson: </label>                        
                    <select
                      className=' '
                      name="salesperson"
                      value={formData.salesperson}
                      onChange={handleChange}
                    >
                      <option value="ALL">ALL</option>
                      {salespersonList.length > 0 && (
                        <>
                        {salespersonList.map((item, index) => {
                            return <>
                                {item['uid'] != null && (
                                <><option value={item['uid']}>{item['name']}</option></>
                                )}
                            </>
        
                        })}     
                        </>
                      )}                        
                    </select>
                    <div>
                      <label>Products:</label>
                      <select 
                        name="courses" 
                        size="15" 
                        className="form-select"
                        multiple
                        onChange={handleCoursesChange}
                        value={formData.courses}
                      >
                        { Object.keys(courseList).length > 0 && (
                              <>
                                  { Object.keys(courseList).map((key) => {
                                      return <>
                                        
                                              <option value={key}>{courseList[key]}</option>
                                          
                                      </>
                                  })}  
                              </>
                          )}
                      </select>
                      <div style={{marginTop:"2%"}}>*To select more than one product, hold the Command/Ctrl key and click on as many as you want.</div>
                    </div>
                    <label htmlFor="pay">Payment Method</label>
                    <select 
                      id="pay" 
                      name="payment_method" 
                      className="sales-report-byproduct-formselect" 
                      value= {formData.payment_method} 
                      onChange={handleChange}
                    >
                      <option value="All">All</option>
                      <option value="sezzle">Sezzle</option>
                      <option value="authnet_aim">Credit Card</option>
                      <option value="paypal_wps">Paypal</option>
                    </select>                                         
                  </div>               
                  <div className="">
                    <input type="submit" value="Submit" className="form-submit"/>&nbsp; &nbsp;
                    <input type="button" value="Export" className="form-submit"  onClick={handleExport}/>
                  </div>
                </form>
                {submittedData && (
                  <>
                  <div className="total-records">
                    <table style={{width:"99%"}}>
                      <thead>
                        <tr>
                        {headers.map((header, index) => (
                          <th key={index}>{header}</th>
                        ))}
                        </tr>
                      </thead>
                      <tbody>
                        {summaryData.map((row, idx) => (
                          <tr key={idx}>
                           
                            <td>{row.pre_app}</td>
                             <td>{row.full_app}</td>
                            <td>{row.total_amount}</td>
                            <td>{row.new_dollars_collected}</td>
                            <td>{row.sale_amount}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>          
                  <div className="new-dollars-table">
                    <label>New Dollars Collected</label>
                    <table className="">
                      <div style={{ width: '100%' }}>
                        <DataGrid
                          rows={rows}
                          columns={columnsNewDollar}
                          rowCount={rowCount}
                          paginationMode="server"
                          sortingMode="server"
                          filterMode="server"
                          paginationModel={paginationModel}
                          onPaginationModelChange={setPaginationModel}
                          sortModel={sortModel}
                          onSortModelChange={setSortModel}
                          filterModel={filterModel}
                          onFilterModelChange={setFilterModel}
                          pageSizeOptions={[5, 10, 25,50]}
                          getRowId={() => crypto.randomUUID()}
                          getRowHeight={() => 'auto'}
                          disableColumnFilter 
                          //disableColumnResize={true}
                        />
                      </div>
                    </table>
                  </div>
                  <div className="recurring-dollars-table">
                    <label>Recurring Dollars Collected</label>
                    <table className="">
                      <div style={{ width: '100%' }}>
                        <DataGrid
                          rows={rowsRecurringDollar}
                          columns={columnsRecurringDollar}
                          rowCount={rowCountRecurringDollar}
                          paginationMode="server"
                          sortingMode="server"
                          filterMode="server"
                          paginationModel={paginationModelRecurringDollar}
                          onPaginationModelChange={setPaginationModelRecurringDollar}
                          sortModel={sortModelRecurringDollar}
                          onSortModelChange={setSortModelRecurringDollar}
                          filterModel={filterModelRecurringDollar}
                          onFilterModelChange={setFilterModelRecurringDollar}
                          pageSizeOptions={[5, 10, 25,50]}
                          getRowId={() => crypto.randomUUID()}
                          getRowHeight={() => 'auto'}
                          disableColumnFilter 
                          //disableColumnResize={true}
                        />
                      </div>
                    </table>
                  </div>
                </>
                )}
              </div>
            </div>
            <div className="right"></div>
        </div>
        )}
      </>
  );
};
export default SalesandAppsReport;